module.exports = __webpack_public_path__ + "img/home_map.32e4dfcf.png";